export const postMessage = ({ state }, payload) => {
  opener.postMessage(
    { event: payload.event, message: payload.message },
    state.shopDomain
  );
};
